/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import {faker} from '@faker-js/faker';
import {PersonName} from 'spine-web/proto/spine/people/person_name_pb';

/**
 * Utilities for the `PersonName`.
 */
export default class PersonNames {

  /**
   * Formats the name in the associated `PersonName` instance as a human-readable full name text.
   */
  static format(personName: PersonName): string {
    const name = personName;
    if (!name) {
      return '';
    }
    return [
      name.getGivenName(),
      name.getMiddleName(),
      name.getFamilyName()
    ].filter(n => !!n)
     .join(' ');
  }
}

// ========================== Sample data creation functions ==========================

/**
 * Creates a random `PersonName` instance.
 */
export function samplePersonName(name?: string): PersonName {
  if (name === undefined) {
    name = faker.name.findName();
  }
  const parts = name.split(' ');
  const givenName = parts[0];
  const familyName = parts.length > 1 ? parts[parts.length - 1] : undefined;
  const middleName = parts.length > 2 ? parts[1] : undefined;

  return new PersonName()
      .setGivenName(givenName)
      .setMiddleName(middleName)
      .setFamilyName(familyName)
}
